<template>
	<header ref="header" class="header" :class="{ 'header--sticky': isScrolled }">
		<div class="header__container container">
			<button
				class="btn-icon header__burger-menu-btn"
				:class="{ 'header__burger-menu-btn--active': isBurgerShow }"
				@click="isBurgerShow = !isBurgerShow"
			>
				<SvgIcon id="icon-menu" />
			</button>

			<a href="/" class="header__logo">
				<img src="@/assets/landing/images/logo.svg" alt="logo" />
			</a>

			<div class="header__links">
				<div v-for="item in menuItems" :key="item.id">
					<a :href="item.url" :target="item.target" class="link">
						{{ $t(item.title) }}
					</a>
				</div>
			</div>

			<div class="header__buttons">
				<div class="dropdown">
					<button class="btn-icon dropdown__btn" @click="isLocaleShow = !isLocaleShow">
						<span>
							{{ $i18n.locale }}
						</span>
					</button>

					<Teleport to="body">
						<div
							v-if="isLocaleShow"
							class="dropdown__backdrop"
							@touchmove="isLocaleShow = false"
							@click="isLocaleShow = false"
						></div>
					</Teleport>

					<div
						class="dropdown__content"
						:class="{ 'dropdown__content--expanded': isLocaleShow }"
					>
						<button
							v-for="locale in availableLocales"
							class="dropdown__item"
							:key="locale"
							@click="() => handleChangeLocale(locale)"
						>
							{{ locale }}
						</button>
					</div>
				</div>

				<a
					v-if="isMobile"
					href="/scene"
					class="btn-icon"
					:aria-label="$t('landing.components.app_header.scene')"
				>
					<SvgIcon id="icon-login" />
				</a>

				<button
					v-else
					class="btn-icon"
					:aria-label="$t('landing.components.app_header.show_qr')"
					@click="showQRCode"
				>
					<SvgIcon id="icon-login" />
				</button>
			</div>
		</div>
	</header>

	<div
		class="header__burger-container container"
		:class="{ 'header__burger-container--expanded': isBurgerShow }"
	>
		<Teleport to="body">
			<div
				v-if="isBurgerShow"
				class="header__burger-backdrop"
				@touchmove="isBurgerShow = false"
				@click="isBurgerShow = false"
			></div>
		</Teleport>

		<div class="header__burger-wrapper">
			<div
				v-for="item in menuItems"
				class="header__burger-item"
				:key="item.id"
				@click="isBurgerShow = false"
			>
				<a :href="item.url" :target="item.target" class="link">
					{{ $t(item.title) }}
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import SvgIcon from '@/components/landing/SvgIcon.vue'
import headerMenuData from '@/data/landing/header-menu.json'
import i18n from '@/i18n/index.js'
import { changeLocale } from '@/helpers/landing/changeLocale.js'
import { isMobile } from '@/helpers/isMobile.js'

export default {
	name: 'AppHeader',
	components: { SvgIcon },
	inject: ['showQRCode'],
	data() {
		return {
			menuItems: headerMenuData.items,
			isScrolled: false,
			isBurgerShow: false,
			isLocaleShow: false,
			isMobile: isMobile.any(),
			qrCode: ''
		}
	},
	computed: {
		availableLocales() {
			return i18n.global.availableLocales.filter((locale) => locale !== i18n.global.locale)
		}
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll)

		if (this.$route.hash) {
			setTimeout(() => {
				this.scrollToSection(this.$route.hash.replace('#', ''))
			}, 0)
		}
	},
	unmounted() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	methods: {
		handleScroll() {
			this.isScrolled = window.scrollY > 0
		},
		scrollToSection(id) {
			const targetElement = document.getElementById(id)

			if (!targetElement) return

			const offset = this.$refs.header.offsetHeight
			const elementPosition = targetElement.getBoundingClientRect().top
			const offsetPosition = elementPosition + window.scrollY - offset

			window.scrollTo({
				top: offsetPosition,
				behavior: 'smooth'
			})
		},
		handleChangeLocale(locale) {
			changeLocale(locale)
			this.isLocaleShow = false
		}
	}
}
</script>
